// services/accountService.js
import { CollectionUrl1, CollectionUrl2, SaveRecievedUrl, ACCOUNTS_LIST_URL } from "../../../api/apiurls";

export const fetchAccountsFromApi = async (agentUserName) => {
  try {
    const res = await fetch(ACCOUNTS_LIST_URL + agentUserName);
    if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
    return await res.json();
  } catch (err) {
    console.error("Error fetching accounts", err);
    return [];
  }
};
export const saveAccountData = async (data) => {
  const response = await fetch(SaveRecievedUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });

  const result = await response.text();

  console.log("Save Response:", result);

  if (!response.ok) {
    throw new Error(result);
  }

  return result;
};

// export const saveAccountData = async (data) => {
//   await fetch(SaveRecievedUrl, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(data)
//   });
// };

export const fetchAccountDetails = async (accNoToFetch,agentName) => {
  // let response = await fetch(CollectionUrl2 + accNoToFetch);
    let response = await fetch(`${CollectionUrl2}${accNoToFetch}/${agentName}/`);

  return await response.json();
};
export const fetchAccountFallback = async (accNoToFetch) => {
  let response2 = await fetch(CollectionUrl1 + accNoToFetch);
  let data = await response2.json();   // ✅ call once
  console.log("Fallback response:", data);
  return data;                         // ✅ reuse same parsed object
};
